import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ConfigProvider } from "../../../config-provider.service";
import { CurrentUser } from "../../../common/providers/current-user";
import {
    FeedbackAthleteAnswerProvider,
    LatestFeedbackData
} from '../../../feedback/providers/feedback-athlete-answer-provider';
import { Observable, Subscription, tap } from 'rxjs';
import { Organization } from "../../../common/models/organization";
import { Athlete } from "../../../common/models/athlete";
import { TranslateModule } from "@ngx-translate/core";
import { DatePipe, NgForOf, NgIf } from "@angular/common";
import { RouterLink } from "@angular/router";
import { MatMiniFabButton } from "@angular/material/button";
import { MatLine } from "@angular/material/core";
import { MatIcon } from "@angular/material/icon";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatTooltip } from "@angular/material/tooltip";
import { MatListItem } from "@angular/material/list";
import { catchError, map } from "rxjs/operators";
import { User } from "../../../common/models/user";

@Component({
  selector: 'athlete-feedback-box',
  standalone: true,
  providers: [],
  styleUrls: ['./feedback-box.scss'],
  imports: [
    TranslateModule,
    DatePipe,
    NgForOf,
    NgIf,
    RouterLink,
    MatMiniFabButton,
    MatLine,
    MatIcon,
    MatProgressSpinner,
    MatTooltip,
    MatListItem
  ],
  templateUrl: './feedback-box.html'
})
export class FeedbackBoxComponent implements OnInit, OnDestroy {
    public isLoading = true;
    public is401 = false;
    public is404 = false;

    @Input()
    public organization: Organization | null = null;

    @Input()
    public athleteUser: User = {} as User;

    public latestFeedbackData: LatestFeedbackData[] = [];
    private subscriptions: Subscription[] = [];

    constructor(
        private feedbackAthleteAnswerProvider: FeedbackAthleteAnswerProvider,
        public conf: ConfigProvider,
        public currentUser: CurrentUser,
    ) {
    }

    public ngOnInit() {
        this.loadData().subscribe();
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
    public loadData(): Observable<void> {
      return this.feedbackAthleteAnswerProvider.findLatestFeedback(this.organization!, this.athleteUser.athlete!).pipe(
        map(data => data.map(d => new LatestFeedbackData(
          d.answerLabel,
          d.answerUserData,
          d.answerValue,
          d.answeredAt,
          d.questionTitle,
          d.questionType
        ))),
        map(latestFeedbackData => {
          this.latestFeedbackData = latestFeedbackData;
          this.isLoading = false; // Assuming you want to set loading to false after data is set
        }),
        catchError(error => {
          this.onError(error);
          throw error; // Rethrow the error if you need to mark this observable as errored
        })
      );
    }

    private onError(error: any): void {
        this.isLoading = false;

        if (error.status === 404) {
            this.is404 = true;
        } else if (error.status === 401) {
            this.is401 = true;
        }
    }
}
